import { render, staticRenderFns } from "./InsightsPanel.vue?vue&type=template&id=60d73992&"
import script from "./InsightsPanel.vue?vue&type=script&lang=js&"
export * from "./InsightsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports